import { abortableFetch, useEventCallback } from '@eas/common-web';
import { UserRole } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEditUserRoleDialog() {
  const callApi = useEventCallback((userRoleId: string, formData: UserRole) => {
    return abortableFetch(`${EvidenceApiUrl.USER_ROLE}/${userRoleId}`, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(formData),
    });
  });

  return {
    callApi,
  };
}
